import Image from 'next/legacy/image';

import { useMediaQuery } from '@/hooks';

export type DietaryTagsType = {
  dietaryTags: Array<any>;
  size?: string;
};

export const DietaryTags: React.FC<DietaryTagsType> = ({
  dietaryTags,
}: DietaryTagsType) => {
  const isMobile = useMediaQuery(`(max-width:767px)`);
  const sizes = { width: 20, height: 22 };
  if (isMobile) {
    sizes.width = 20;
    sizes.height = 20;
  }
  return (
    <div className="flex items-center pl-1">
      {dietaryTags &&
        dietaryTags.slice(0, 2).map((tag: any, index: number) => (
          <div key={index} className="mx-1 flex">
            <Image
              src={tag.icon.url}
              width={sizes.width}
              height={sizes.height}
              alt=""
            />
          </div>
        ))}
    </div>
  );
};
